module.exports = __webpack_public_path__ + "img/sure.1eac45f6.svg";